import React from 'react';
import { defaultValidateMessages } from './constants';
export const FormContext = React.createContext({
    labelAlign: 'right',
    validateMessages: defaultValidateMessages,
    form: null,
});
